export default __webpack_public_path__ + "static/media/MenuIcon.0ff86dea.svg";